import { render, staticRenderFns } from "./AttacksEvolutionByHour.vue?vue&type=template&id=2244edc8&scoped=true"
import script from "./AttacksEvolutionByHour.vue?vue&type=script&lang=ts"
export * from "./AttacksEvolutionByHour.vue?vue&type=script&lang=ts"
import style0 from "./AttacksEvolutionByHour.vue?vue&type=style&index=0&id=2244edc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2244edc8",
  null
  
)

export default component.exports